module.exports = __webpack_public_path__ + "img/pdf_icon.3a6daea9.svg";